import React, { useState } from 'react'

const ImageWithLoading = ({ 
    src, 
    alt, 
    className = '', 
    fallbackSrc = null,
    showLoader = true 
}) => {
    const [isLoading, setIsLoading] = useState(true)
    const [hasError, setHasError] = useState(false)
    const [currentSrc, setCurrentSrc] = useState(src)

    const handleLoad = () => {
        setIsLoading(false)
        setHasError(false)
    }

    const handleError = () => {
        setIsLoading(false)
        setHasError(true)
        
        // Try fallback image if available
        if (fallbackSrc && currentSrc !== fallbackSrc) {
            setCurrentSrc(fallbackSrc)
            setIsLoading(true)
            setHasError(false)
        }
    }

    return (
        <div className={`image-container ${className}`}>
            {isLoading && showLoader && (
                <div className="image-loader">
                    <div className="image-loader__spinner"></div>
                </div>
            )}
            
            {hasError ? (
                <div className="image-error">
                    <span>📷</span>
                    <p>Image not available</p>
                </div>
            ) : (
                <img
                    src={currentSrc}
                    alt={alt}
                    onLoad={handleLoad}
                    onError={handleError}
                    style={{
                        opacity: isLoading ? 0 : 1,
                        transition: 'opacity 0.3s ease-in-out'
                    }}
                />
            )}
        </div>
    )
}

export default ImageWithLoading 